import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import styles from './styles';
import { constructGTM } from '../../../../../../utilities/helpers';
import Button from '../../../../../Button';
import {
  setRegistrationCurrentStep,
  signUp,
} from '../../../../../../store/actions/registration';
import {
  selectBuilderProjectGallery,
  selectRegistrationInfo,
  selectRegistrationIsSubmitting,
} from '../../../../../../store/selectors';
import { NOTIFICATION_STATUSES } from '../../../../../NotificationSettingsContainer';
import { USER_ROLE_TYPES } from '../../../../../../constants';

const propTypes = {
  onSetRegistrationCurrentStep: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  registrationInfo: PropTypes.shape({
    'custom:personalEmail': PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  onSignUp: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export const StepTwo = props => {
  const {
    classes,
    onSetRegistrationCurrentStep,
    registrationInfo,
    onSignUp,
    isSubmitting,
    builderProjectGallery,
  } = props;

  const handleEdit = () => {
    // Log event to GTM
    TagManager.initialize(
      constructGTM({
        dataLayer: {
          event: 'Registration step 3/3 - edit details',
        },
      }),
    );
    onSetRegistrationCurrentStep(0);
  };

  const handleSubmit = () => {
    const projectGalleryImages = builderProjectGallery.map(image => image.file);
    const attributes = { ...registrationInfo, projectGalleryImages };
    delete attributes.password;
    delete attributes.legal;
    delete attributes['custom:buildingLicExpMask'];
    attributes['custom:marketingOptIn'] =
      attributes['custom:marketingOptIn'] === true ? 'Y' : 'N';

    if (registrationInfo['custom:roleType'] === USER_ROLE_TYPES.BUILDER.code) {
      attributes['custom:buildingLicExp'] = moment(
        attributes['custom:buildingLicExp'],
      ).format('YYYY-MM-DD');
    }

    // we will enable email notification for all users during registration
    attributes['custom:emailNotiStatus'] = NOTIFICATION_STATUSES.ENABLED;

    // Enable SMS notifications for builders during registration
    if (
      registrationInfo['custom:roleType'] === USER_ROLE_TYPES.BUILDER.code &&
      registrationInfo['custom:mobileNumber']
    ) {
      attributes['custom:smsNotiStatus'] = NOTIFICATION_STATUSES.ENABLED;
    }

    const signUpData = {
      username: registrationInfo['custom:personalEmail'],
      password: registrationInfo.password,
      attributes,
    };

    // Log submit event to GTM
    TagManager.initialize(
      constructGTM({
        dataLayer: {
          event: 'Registration step 3/3 - success',
        },
      }),
    );

    console.log('came here', 'sign');
    // console.log({ signUpData });
    onSignUp(signUpData);
  };

  return (
    <>
      <div className={classes.leftButton}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleEdit}
          disabled={isSubmitting}
        >
          Edit Details
        </Button>
      </div>
      <div className={classes.rightButton}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          Submit
          {isSubmitting && (
            <CircularProgress className={classes.progress} size={20} />
          )}
        </Button>
      </div>
    </>
  );
};

StepTwo.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  registrationInfo: selectRegistrationInfo(),
  isSubmitting: selectRegistrationIsSubmitting(),
  builderProjectGallery: selectBuilderProjectGallery(),
});

const mapDispatchToProps = dispatch => ({
  onSetRegistrationCurrentStep: step =>
    dispatch(setRegistrationCurrentStep(step)),
  onSignUp: data => dispatch(signUp(data)),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(StepTwo),
);
